export type SingolaColonna = {
  field: string;
  header: string;
};
export const ClientiColumns: SingolaColonna[] = [
  { field: "protocollo", header: "Protocollo" },
  { field: "ragioneSociale", header: "Ragione Sociale" },
  { field: "partitaIva", header: "P.Iva" },
  { field: "tipologia", header: "Tipologia" },
  { field: "email", header: "Email" },
  { field: "telefono", header: "Telefono" },
  { field: "citta", header: "Città" },
];

export const CantieriColumns: SingolaColonna[] = [
  { field: "nome", header: "Nome" },
  { field: "codiceContratto", header: "n° Contratto" },
  { field: "dataInizio", header: "Data Inizio" },
  { field: "dataFineEffettiva", header: "Data Fine" },
  { field: "nomeReferente", header: "Referente" },
  { field: "stato", header: "Stato" },
  { field: "importo", header: "Importo" },
  { field: "subappalto", header: "Subappalto" },
];
export const ContrattiColumns: SingolaColonna[] = [
  { field: "codice", header: "n° Contratto" },
  { field: "nomeCommittente", header: "Committente" },
  { field: "dataInizioDisplay", header: "Data Inizio" },
  { field: "dataFineDisplay", header: "Data Fine" },
  { field: "importo", header: "Importo" },
  { field: "nomeReferente", header: "Referente" },
];
export const EventiColumns: SingolaColonna[] = [
  { field: "titolo", header: "Titolo" },
  { field: "dataOra", header: "Data Inizio" },
  { field: "scadenza", header: "Scadenza" },
  { field: "committente", header: "Committente" },
  { field: "contrattoQuadro", header: "Contratto Quadro" },
  { field: "cantiere", header: "Cantiere" },
];
export const UtentiColumns: SingolaColonna[] = [
  { field: "nome", header: "Nome" },
  { field: "cognome", header: "Cognome" },
  { field: "email", header: "Email" },
  { field: "ruolo", header: "Ruolo" },
  { field: "tipoUtente", header: "Tipo" },
];
